export default "/images/2bcf3919fe93d24f01845bf38804ef0f.jpg";